module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "userRegistrationForm"
    }
  }, [_c('table', {
    staticClass: "registration-form"
  }, [_c('tr', [_c('td', [_vm._v("ユーザー名:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalUser.name),
      expression: "additionalUser.name"
    }],
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "ユーザー名"
    },
    domProps: {
      "value": (_vm.additionalUser.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.additionalUser, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("パスワード:")]), _vm._v(" "), _c('td', [(_vm.isPasswordShown) ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalUser.password),
      expression: "additionalUser.password"
    }],
    attrs: {
      "type": "text",
      "name": "password",
      "placeholder": "パスワード"
    },
    domProps: {
      "value": (_vm.additionalUser.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.additionalUser, "password", $event.target.value)
      }
    }
  })] : [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalUser.password),
      expression: "additionalUser.password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "パスワード"
    },
    domProps: {
      "value": (_vm.additionalUser.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.additionalUser, "password", $event.target.value)
      }
    }
  })]], 2), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isPasswordShown),
      expression: "isPasswordShown"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isPasswordShown) ? _vm._i(_vm.isPasswordShown, null) > -1 : (_vm.isPasswordShown)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isPasswordShown,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isPasswordShown = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isPasswordShown = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isPasswordShown = $$c
        }
      }
    }
  }), _vm._v("パスワードを表示する")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("氏名:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalUser.fullname),
      expression: "additionalUser.fullname"
    }],
    attrs: {
      "type": "text",
      "name": "fullname",
      "placeholder": "氏名"
    },
    domProps: {
      "value": (_vm.additionalUser.fullname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.additionalUser, "fullname", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("フリガナ:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalUser.kana),
      expression: "additionalUser.kana"
    }],
    attrs: {
      "type": "text",
      "name": "kana",
      "placeholder": "フリガナ"
    },
    domProps: {
      "value": (_vm.additionalUser.kana)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.additionalUser, "kana", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("mail:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalUser.mail_address),
      expression: "additionalUser.mail_address"
    }],
    attrs: {
      "type": "text",
      "name": "mail_address",
      "placeholder": "mail_address"
    },
    domProps: {
      "value": (_vm.additionalUser.mail_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.additionalUser, "mail_address", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ユーザー種別：")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalUser.type),
      expression: "additionalUser.type"
    }],
    staticClass: "typeSelect",
    attrs: {
      "name": "usertype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.additionalUser, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "student",
      "selected": ""
    }
  }, [_vm._v("生徒")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "teacher"
    }
  }, [_vm._v("教師")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "admin"
    }
  }, [_vm._v("管理者")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "viewer"
    }
  }, [_vm._v("閲覧者")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ユーザー状態：")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalUser.status),
      expression: "additionalUser.status"
    }],
    staticClass: "statusSelect",
    attrs: {
      "name": "userstatus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.additionalUser, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "normal",
      "selected": ""
    }
  }, [_vm._v("通常")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "temporal"
    }
  }, [_vm._v("短期（単一）")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "trial"
    }
  }, [_vm._v("体験")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "temp/temp"
    }
  }, [_vm._v("短期（複数、元体験生）")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "temp/norm"
    }
  }, [_vm._v("短期及び長期")])])])])]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.registerUser
    }
  }, [_vm._v("ユーザーを登録する")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4eaa402a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4eaa402a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ManagementPage/UserRegistrationForm.vue
// module id = 712
// module chunks = 0